<script>
    import {sgettext} from '../../i18n.js';

    export let status = '';
</script>

<style>
    .badge {
        margin: 0 3px;
    }

    .badge-light {
        color: #454545;
        border: 1px solid #454545;
    }

    .badge-approved {
        color: white;
        background-color: #2b2b2b;
        border: 1px solid #2b2b2b;
    }

    .badge-pending {
        color: white;
        background-color: #0DA2FF;
    }

    .badge-current {
        color: white;
        background-color: #5CB85C;
    }

    .badge-rejected {
        color: white;
        background-color: #D9534F;
    }
</style>
{#if status === 'Approved'}
    <span class="badge badge-pill badge-approved">{sgettext('$$SUPERSEDED_1$$')}</span>
{:else if status?.toLowerCase() === 'pending'}
    <span class="badge badge-pill badge-pending">{status}</span>
{:else if status?.toLowerCase() === 'current'}
    <span class="badge badge-pill badge-current">{status}</span>
{:else if status?.toLowerCase() === 'rejected'}
    <span class="badge badge-pill badge-rejected">{status}</span>
{:else if status}
    <span class="badge badge-pill badge-light">{status}</span>
{/if}